/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';
import Typography from '@digital-hig/typography';
import InputAdornment from '@mui/material/InputAdornment';
import SvgSearch from '@digital-hig/icon/lib/build/icons/actions/search';
import { useTranslation } from 'react-i18next';
import { SRPContext } from '../../../common/context/srpContext';
import SearchRootElement from './style';
import { SRPStateInterface } from '../../../common/context/srpInterface';

const Search = () => {
  const { t } = useTranslation();
  const {
    srpStateRef = { current: SRPStateInterface },
    appliedFilter,
    setAppliedFilter,
    fetchPartnersData,
    dispatch,
  } = useContext(SRPContext);

  const [searchText, setTearchText] = useState('');
  const onInputChange = ({ target }) => {
    setTearchText(target.value);
  };
  const onKeyPress = async (e) => {
    if (e.key === 'Enter') {
      const applyData = srpStateRef?.current?.appliedFilter || appliedFilter;
      const filter = { ...applyData, search: e.target.value, pageNumber: 1 };
      setAppliedFilter(filter);
      dispatch({ type: 'GET_SRP_LISTING', payload: [] });
      await fetchPartnersData({
        search: filter,
        isSearch: true,
      });
    }
  };

  useEffect(() => {
    setTearchText(appliedFilter?.search || '');
  }, [appliedFilter]);

  return (
    <SearchRootElement>
      <Box className="page-container">
        <Typography className="search-title">
          {t('Search for software or a company')}
        </Typography>
        <TextField
          className="search-field"
          onChange={onInputChange}
          onKeyPress={onKeyPress}
          type="search"
          placeholder={`${t('Search')}…`}
          value={searchText}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgSearch />
              </InputAdornment>
            ),
          }}
          variant="standard"
          data-wat-val={searchText.trim() ? searchText : 'HeroBanner Search'}
          data-wat-loc="search"
        />
      </Box>
    </SearchRootElement>
  );
};

export default Search;
